import {createRoot} from "react-dom/client"
import React from 'react'
import {Provider, connect} from 'react-redux'
import './reducers'
import {DeliveryDateFrame, RingRecipientFrame, CenterStoneFrame, DesignVisionFrame} from './engagement'
import {ChooseCategoryTopFrame, ChooseCategorySecondaryFrame} from './non_engagement'
import {ClassRingMetalColor, ClassRingFinish, ClassRingGemstones, ClassRingFaceShape, ClassRingRaisedOrRecessed, ClassRingShoulderDesigns, ClassRingFaceSize, ClassRingNextSteps} from './class_ring'
import {SignetMetalColor, SignetFinish, SignetGemstones, SignetFaceShape, SignetRaisedOrRecessed, SignetShoulderDesigns, SignetRingFaceSize, SignetNextSteps} from './signet'
import {PendantMetalColor, PendantFinish, PendantGemstones, SolidOrCutout, PendantShape, PendantSize, PendantNextSteps, PendantChainLength, PendantChainStyles} from './pendant'
import {trackEventSP} from 'js/studios/shared/tracking'
import {BudgetFrame, nextFrame, LowBudgetPreventionFrame, ShippingLocationFrame, SourceFrame, ShareYourIdea} from './shared'
import {Splash} from 'js/studios/shared/flows'
import {Registration} from './registration'
import {keyActivationHandler} from 'js/studios/shared/utils'

const CATEGORY_CTA_MAPPING = {
  'signet_ring': 'a signet ring',
  'class_ring': 'a class ring',
  'engagement_ring': 'an engagement ring',
  'necklace': 'a necklace',
  'earrings': 'earrings',
  'cufflinks': 'cufflinks',
  'lapelpin': 'a pin',
}


@connect(state => ({sourceCategory: state.projectCreationData.sourceCategory, splashImage: state.projectCreation.splashImage}))
class Welcome extends React.Component {
  goToGenericFlow = (_e) => {
    trackEventSP('click_switch_to_generic_flow', 'consultation', {
      source_category: this.props.sourceCategory,
    })
    this.props.dispatch({type: "PROJECT_CREATION_UPDATE_TO_GENERIC_FLOW"})
    nextFrame()
  }

  splashBodyHtml() {
    return <React.Fragment>
      <a className="btn btn-primary btn-sm" tabIndex="0" onClick={nextFrame} onKeyDown={keyActivationHandler(nextFrame)}>Let's Go</a>
      {this.props.sourceCategory && CATEGORY_CTA_MAPPING[this.props.sourceCategory] &&
        <a
          className="back-link text-link"
          tabIndex="0"
          onClick={this.goToGenericFlow}
          onKeyDown={keyActivationHandler(this.goToGenericFlow)}>
            Not creating {CATEGORY_CTA_MAPPING[this.props.sourceCategory]}?
        </a>}
    </React.Fragment>
  }

  splashImageClass() {
    if (this.props.splashImage) {
      return this.props.splashImage
    } else if (this.props.sourceCategory) {
      return this.props.sourceCategory
    }

    return ''
  }

  render() {
    return <Splash splashClassName={this.splashImageClass()}>
      <h1>Let's Make Something Amazing</h1>
      <p>Before we begin, we'd like to learn a bit about what you're looking for so we can give you the best experience possible.</p>
      {this.splashBodyHtml()}
    </Splash>
  }
}


@connect(state => ({
  projectCreation: state.projectCreation,
  projectCreationData: state.projectCreationData,
  preventionFrame: state.projectCreation.preventionFrame,
}))
class ProjectCreation extends React.Component {

  generateFrames(){
    let frames = [<Welcome key="welcome" name="welcome" />]
    let flow = this.props.projectCreation.flow
    let projectCreationData = this.props.projectCreationData
    if (flow === 'generic'){
      frames.push(<ChooseCategoryTopFrame key="choose-category-top" name="choose-category-top" />)
    }

    if (flow === 'engagement' || projectCreationData.categoryTop === 'engagement'){
      frames = frames.concat([
        <RingRecipientFrame key="recipient" name="recipient" />,
        <DesignVisionFrame key="design-vision" name="design-vision" />,
        <CenterStoneFrame key="center-stone" name="center-stone" />,
        <BudgetFrame key="budget" name="budget" />,
        <DeliveryDateFrame key="delivery-date" name="delivery-date" />
      ])
    } else {
      if (!this.props.projectCreationData.sourceCategory){
        frames.push(
          <ChooseCategorySecondaryFrame key="choose-category-secondary" name="choose-category-secondary" />
        )
      }

      if (projectCreationData.categorySecondary === "signet_ring" || this.props.projectCreationData.sourceCategory === 'signet_ring') {
        frames = frames.concat([
          <SignetMetalColor key="metal-color" name="metal-color" />,
          <SignetFinish key="finish" name="finish" />,
          <SignetGemstones key="gemstones" name="gemstones" />,
          <SignetFaceShape key="ring-face-shape" name="ring-face-shape" />,
          <SignetRingFaceSize key="ring-face-size" name="ring-face-size" />,
          <SignetRaisedOrRecessed key="raised-or-recessed" name="raised-or-recessed" />,
          <SignetShoulderDesigns key="shoulder-designs" name="shoulder-designs" />,
          <ShareYourIdea key="share-your-idea" name="share-your-idea" />,
          <BudgetFrame key="budget" name="budget" />,
          <SignetNextSteps key="next-steps" name="next-steps" />,
        ])
      } else if (projectCreationData.categorySecondary === "necklace" || this.props.projectCreationData.sourceCategory === 'necklace'){
        frames = frames.concat([
          <PendantMetalColor key="pendant-metal-color" name="pendant-metal-color" />,
          <PendantFinish key="pendant-finish" name="pendant-finish" />,
          <PendantGemstones key="pendant-gemstones" name="pendant-gemstones" />,
          <SolidOrCutout key="solid-or-cutout" name="solid-or-cutout" />,
          <PendantShape key="pendant-face-shape" name='pendant-face-shape' />,
          <PendantSize key="pendant-face-size" name="pendant-face-size" />,
          <PendantChainLength key="pendant-chain-length" name='pendant-chain-length' />,
          <PendantChainStyles key="pendant-chain-styles" name='pendant-chain-styles' />,
          <ShareYourIdea key="share-your-idea" name="share-your-idea" />,
          <BudgetFrame key="budget" name="budget" />,
          <PendantNextSteps key="pendant-next-steps" name="pendant-next-steps" />,
        ])
      } else if (projectCreationData.categorySecondary === "class_ring" || this.props.projectCreationData.sourceCategory === 'class_ring'){
        frames = frames.concat([
          <ClassRingMetalColor key="metal-color" name="metal-color" />,
          <ClassRingFinish key="finish" name="finish" />,
          <ClassRingGemstones key="gemstones" name="gemstones" />,
          <ClassRingFaceShape key="ring-face-shape" name="ring-face-shape" />,
          <ClassRingFaceSize key="ring-face-size" name="ring-face-size" />,
          <ClassRingRaisedOrRecessed key="raised-or-recessed" name="raised-or-recessed" />,
          <ClassRingShoulderDesigns key="shoulder-designs" name="shoulder-designs" />,
          <ShareYourIdea key="share-your-idea" name="share-your-idea" />,
          <BudgetFrame key="budget" name="budget" />,
          <ClassRingNextSteps key="next-steps" name="next-steps" />,
        ])
      } else {
        frames = frames.concat([
          <ShareYourIdea key="share-your-idea" name="share-your-idea" />,
          <BudgetFrame key="budget" name="budget" />
        ])
      }
    }

    frames.push(
      <ShippingLocationFrame key="shipping-location" name="shipping-location" />,
      <SourceFrame key="source" name="source" />,
      <Registration key="registration" name="registration" />
    )

    return frames
  }

  componentDidUpdate(prevProps, _prevState){
    let frame = this.props.projectCreation.frame
    let prevFrame = prevProps.projectCreation.frame
    if (prevFrame !== frame){
      let action = 'action_next_creation_frame'
      if (prevFrame > frame){
        action = 'action_previous_creation_frame'
      }
      trackEventSP(action, 'consultation', {
        frame: this.generateFrames()[frame].props.name
      })
    }
  }

  render(){
    let frame = null
    if (this.props.preventionFrame === 'prevention-low-budget'){
      frame = <LowBudgetPreventionFrame key="low-budget-prevention" name="low-budget-prevention" />
    } else {
      frame = this.generateFrames()[this.props.projectCreation.frame]
    }
    return (
      <div className="flow-wrapper">
        {frame}
      </div>
    )
  }
}

createRoot(document.getElementById('project_creation_wrapper')).render(
  <Provider store={window.cm.store}><ProjectCreation /></Provider>
)
